{
    "coordinates": [
        -44.792389308498144,
        168.39006276825592
    ],
    "tooltip": "Holocene New Zealand",
    "title": "Holocene New Zealand",
    "country": "New Zealand",
    "period": "Quaternary",
    "alt": "TODO"
}